import React, { createContext, useContext, ReactNode, useState, Dispatch, SetStateAction, useMemo } from 'react';
import PropTypes from 'prop-types';
import { IFilter } from 'pages/InvoiceLetter/CheckOrders';

export interface IFilterContext {
  filter: IFilter | null;
  setFilter: Dispatch<SetStateAction<IFilter | null>>;
}

const FilterContext = createContext<IFilterContext | undefined>(undefined);

export const FilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [filter, setFilter] = useState<IFilter | null>(null);

  const contextValue = useMemo(() => ({ filter, setFilter }), [filter]);
  
  return <FilterContext.Provider value={contextValue}>{children}</FilterContext.Provider>;
};

FilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within a FilterProvider');
  }
  return context;
};
